"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertySource = void 0;

var _createProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty");

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var PROPERTY_KEY = 'source';
/**
 * @param {Object} upgradeData
 * @param {String} upgradeSource
 * @return {Object}
 */

var getPropertySource = function getPropertySource(_ref, upgradeSource) {
  var app = _ref.app,
      screen = _ref.screen,
      uniqueId = _ref.uniqueId;
  var propertyValue = app + "-" + screen + "-" + _sources.sources[upgradeSource] + "-" + uniqueId;
  return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
};

exports.getPropertySource = getPropertySource;